import { times } from 'lodash';

const CAROUSEL_ITEM_TYPES = {
  NAVIGATION_ARROW_PREV: 'NAVIGATION_ARROW_PREV',
  NAVIGATION_ARROW_NEXT: 'NAVIGATION_ARROW_NEXT',
  COLORWAY: 'COLORWAY',
  EMPTY: 'EMPTY',
};

const buildColorwayPickerSlides = (recommendations, nItemsPerSlide = 6) => {
  // Init
  const slides = [];
  let currentSlide;
  let remainingColorways = [...recommendations];

  // Helpers
  const startNewSlide = () => {
    currentSlide = [];
    slides.push(currentSlide);
  };

  const placeColorwayItem = data => {
    currentSlide.push({ type: CAROUSEL_ITEM_TYPES.COLORWAY, data });
  };

  const placeLeftNavigationArrow = () => {
    currentSlide.push({ type: CAROUSEL_ITEM_TYPES.NAVIGATION_ARROW_PREV });
  };

  const placeRightNavigationArrow = () => {
    currentSlide.push({ type: CAROUSEL_ITEM_TYPES.NAVIGATION_ARROW_NEXT });
  };

  const placeEmptyItem = () => {
    currentSlide.push({ type: CAROUSEL_ITEM_TYPES.EMPTY });
  };

  // Start first slide
  startNewSlide();

  // Iterate over remaining colorways until there are no more
  while (remainingColorways.length > 0) {
    // Take first colorway in list of remaining colorways
    const [currentColorway, ...otherColorways] = remainingColorways;

    // Figure out how many slots are left on current slide
    const slotsLeftOnCurrentSlide = nItemsPerSlide - currentSlide.length;

    // If only one slot left on current slide, either:
    // - place last remaining item on current slide if only one remaining colorway
    // or
    // - fill remaining slot with a right pagination arrow and place remaining items on new slide if more than one remaining colorway
    if (slotsLeftOnCurrentSlide === 1) {
      if (remainingColorways.length === 1) {
        placeColorwayItem(currentColorway);
      } else {
        placeRightNavigationArrow();
        startNewSlide();
        placeLeftNavigationArrow();
        placeColorwayItem(currentColorway);
      }
    } else {
      // Else the current slide still has plenty of space, so just place the current colorway without worrying about pagination
      placeColorwayItem(currentColorway);
    }

    // Shift the array of remaining colors. This removes the current colorway from the list of remaining items.
    remainingColorways = otherColorways;

    // Once all items have been placed on slides, fill up any slots left on current slide with empty items
    if (remainingColorways.length === 0) {
      times(slotsLeftOnCurrentSlide - 1, placeEmptyItem);
    }
  }

  return slides;
};

export { buildColorwayPickerSlides };
